import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';
import { Carousel } from '@express-labs/raven-ui';
import { cn } from '@express-labs/raven-tools';

import s from './PromoCodeCarousel.scss';
import PromoCode from './PromoCode';
import { ResizeContext } from '../../../../../../contexts/Resize/Resize';
import { getMemberWallet } from '../../../../../../queries';
import { MAX_MOBILE_WIDTH } from '../../../../../../constants';
import PromoMessage from './PromoMessage';

function PromoCodeCarousel({
  isAssociate,
  loyaltyId,
  memberWalletEnhancement,
}) {
  const { width } = useContext(ResizeContext);
  const { data } = useQuery(getMemberWallet, { variables: { loyaltyId }, skip: isAssociate });
  const deviceWidth = width <= MAX_MOBILE_WIDTH ? 'mobile' : 'desktop';
  let promos = data?.memberWallet?.memberWalletOffers?.filter((item) => item?.type?.toLowerCase() === 'coupon') || [];

  // disabling camelcase for this section because the properties come from a third party
  /* eslint-disable camelcase */
  promos = promos?.map(({
    crm_code, expiry_date, legal_text, details_image, cta_1, cta_2,
    long_description,
    short_description,
    short_description_cta,
    description,
    title,
    subheading,
  }) => ({
    code: crm_code,
    ctaOne: cta_1,
    ctaTwo: cta_2,
    description,
    detailsImage: details_image,
    expiryDate: expiry_date,
    legal: legal_text,
    longDescription: long_description,
    shortDescription: short_description,
    shortDescriptionCta: short_description_cta,
    subheading,
    title,
  }));
  /* eslint-enable camelcase */


  return (
    <div className={s.promoCodeCard}>
      <p className={cn(s.promoInstructions, 'header5')}>
        Your Offers (
        {isAssociate ? 0 : promos?.length}
        )
      </p>
      {promos?.length && !isAssociate ? (
        <div className={s.carouselContainer} data-testid="carousel">
          <Carousel
            deviceWidth={deviceWidth}
            mode="with-html"
            mainImages={promos.map((item) => (
              <PromoCode
                key={item.code}
                code={item.code}
                ctaOne={item.ctaOne}
                ctaTwo={item.ctaTwo}
                description={item.description}
                detailsImage={item.detailsImage}
                expiryDate={item.expiryDate}
                legal={item.legal}
                longDescription={item.longDescription}
                memberWalletEnhancement={memberWalletEnhancement}
                shortDescription={item.shortDescription}
                shortDescriptionCta={item.shortDescriptionCta}
                subheading={item.subheading}
                title={item.title}
              />
            ))}
            slideWidth={250}
            slideHeight={123}
            visibleSlides={0.8}
          />
        </div>
      ) : (
        <PromoMessage isAssociate={isAssociate} />
      )}
    </div>
  );
}

PromoCodeCarousel.propTypes = {
  loyaltyId: PropTypes.string,
  memberWalletEnhancement: PropTypes.bool,
  isAssociate: PropTypes.bool,
};

PromoCodeCarousel.defaultProps = {
  loyaltyId: '',
  memberWalletEnhancement: false,
  isAssociate: false,
};

export default PromoCodeCarousel;
